<mat-toolbar color="primary">Slack Integration</mat-toolbar>

<mat-dialog-content>
  @if (enabled$ | async) {
    <div>
      <button mat-stroked-button (click)="removeIntegration()">
        Remove Slack Integration
      </button>
    </div>
  } @else {
    <a target="_blank" [href]="slackLink$ | async">
      <img
        alt="Add to Slack"
        height="40"
        width="139"
        src="https://platform.slack-edge.com/img/add_to_slack.png"
        srcset="
          https://platform.slack-edge.com/img/add_to_slack.png    1x,
          https://platform.slack-edge.com/img/add_to_slack@2x.png 2x
        "
    /></a>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button type="button" mat-dialog-close>Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
